import { z } from 'zod';

export const setNachversandEligibilityReqDto = z.object({
  eligible: z.boolean(),
});
export type SetNachversandEligibilityReqDto = z.infer<
  typeof setNachversandEligibilityReqDto
>;
